(() => {
  const stickyButton = document.currentScript.closest('section')?.querySelector('[data-sticky-button]');
  const sections = document.querySelectorAll('section');
  const targetButton = document.querySelector('.testimonials__button');

  if (!stickyButton) return;

  let isTargetVisible = false;
  let currentSectionIndex = 0;

  const updateVisibility = () => {
    const isTooEarly = currentSectionIndex < 3;
    if (isTooEarly || isTargetVisible) {
      stickyButton.classList.add('hidden');
    } else {
      stickyButton.classList.remove('hidden');
    }
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.target === targetButton) {
        isTargetVisible = entry.isIntersecting;
      }
      else if (entry.isIntersecting) {
        currentSectionIndex = Array.from(sections).indexOf(entry.target);
      }
      
      updateVisibility();
    });
  }, {
    threshold: 0.1
  });

  sections.forEach(section => observer.observe(section));
  if (targetButton) observer.observe(targetButton);
})();